import { isArray } from 'lodash'
import { Observable, of } from 'rxjs'

import { SelectOption } from '../'
import { QuestionBase, QuestionOptions } from './base.question.class'
import { DropdownCustomQuestionOptions } from './dropdown.question.class'

export interface MultiSelectDropdownQuestionOptions
  extends QuestionOptions<string[]> {
  options?: SelectOption<string>[] | DropdownCustomQuestionOptions
}

export class MultiDropdownQuestion extends QuestionBase<string[]> {
  controlType = 'dropdown'
  declare options: Observable<SelectOption<string>[]>
  multiple = true

  constructor(options: MultiSelectDropdownQuestionOptions = {}) {
    super(options)

    if (this.isCustom) {
      this.options = of(options.options['dropdown-opts'] || [])
    } else if (isArray(options.options)) {
      this.options = of(options.options)
    } else {
      this.options = of([])
    }
  }

  public hasOtherOption() {
    return false
  }
}
